import React, { Component } from 'react'
import { Authenticated, GET_LIST, UPDATE } from 'react-admin'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Snackbar from '@material-ui/core/Snackbar'
import CertificationIcon from '@material-ui/icons/CheckCircle';
import { withStyles } from '@material-ui/core/styles';
import { GenericCreate, GenericEdit, GenericList, GenericShow } from '../Generic'
import CertificationFilters from './CertificationFilters'
import CertificationTable from './CertificationTable'
import dataProvider from '../../utils/dataProvider'


const styles = theme => ({
  title : {
    marginBottom: '20px',
    display: 'inline-flex',
    verticalAlign: 'middle',
    alignItems: 'center',
    fontSize: 23,
    '& svg' : { color: '#019EAC', paddingRight : 10 }
  },
  root: {
    // overflow: 'visible'
  },
  snackbarWarning: {
    backgroundColor: theme.palette.error.light,
  }
})

class ValidarInstalaciones extends Component {
  constructor(props) {
    super(props)

    this.state = {
      empresa: false,
      tipoInstalacion: false,
      tipoInstalacionChoices: [],
      decreto: false,
      decretoChoices: [],
      search: "",

      loading: false,
      tiposInstalaciones: [],
      instalations: {},
      editedInstalations: {},

      sortColumn: "name",
      sortDirection: "ASC",
      visibleIds: [],
      selectedIds: new Set([]),

      totalResults: 0,
      currentPage: 1,
      perPage: 10,

      saving: false,
      snackbarOpen: false,

      inputs: [],
      fields: [],
      title : "",
      singularName : "",
      prueba: []
    }

    this.handlePageChange = this.handlePageChange.bind(this);
    this.handlePerPageChange = this.handlePerPageChange.bind(this);
    this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.doTheThing = this.doTheThing.bind(this)
    this.debouncedThing = _.debounce(this.doTheThing, 1000)
    this.handleChangeSelectedStatusActivos = this.handleChangeSelectedStatusActivos.bind(this);
    this.handleChangeSelectedStatusSql = this.handleChangeSelectedStatusSql.bind(this);
    this.handleChangeAllStatusActivos = this.handleChangeAllStatusActivos.bind(this);
    this.handleChangeAllStatusSql = this.handleChangeAllStatusSql.bind(this);
    this.fetchResults = this.fetchResults.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSnackbarClose = this.handleSnackbarClose.bind(this);
    // this.getDecreto = this.getDecreto.bind(this);
    // this.setState({
    //   decretos : this.getDecreto()
    // })
  }

  

  handleFilterChange = () => (event, value, old_value, name) => {
    if (name === "tipoInstalacion") {
      const { tiposInstalaciones } = this.state
      // const decretoChoices = _.map(tiposInstalaciones[value].decreto,
      //   (value, key) => {
      //     return { value: key, text: value.name }
      //   }
      // ).sort((a, b) => {
      //   if (a.text < b.text) return -1
      //   if (a.text === b.text) return 0
      //   return 1
      // })
      
      // const params = {
      //   pagination: {
      //     page: 1,
      //     perPage: 1000
      //   },
      //   sort: {
      //     field: 'id',
      //     order: 'ASC'
      //   },
      //   filter: {
      //     slug: tiposInstalaciones[value].slug
      //   }
      // }
      // dataProvider(GET_LIST, 'decretos', params)
      //   .then(result => {
      //     console.log(result)
      //     if (result.total >= 0){
      //       const decretoChoices = result.data
      //       const title = result.data[0].name
      //       return {
      //         title,
      //         decretoChoices
      //       }
      //     } else {
      //       return {
      //         title : "",
      //         decretoChoices: null
      //       }
      //     }
      //   })

      this.setState({
        tipoInstalacion: value,
        totalResults: 0,
        // decretoChoices: decretoChoices,
        decreto: false,
        instalations: {},
        editedInstalations: {},
        visibleIds: []
      }, () => {
        this.fetchResults()
      })
    } else if (name === "empresa") {
      this.setState({
        empresa: value,
        totalResults: 0,
        instalations: {},
        editedInstalations: {},
        visibleIds: []
      }, () => {
        if (!!this.state.tipoInstalacion) { this.fetchResults() }
      })
    } else if (name === "decreto") {
      this.setState({ 
        decreto: value ,
        totalResults: 0,
        instalations: {},
        editedInstalations: {},
        visibleIds: []
      }, () =>{
        if (!!this.state.tipoInstalacion) { this.fetchResults() }
      })
    }
  }

  handleSearchChange = () => (event, value, old_value, name) => {
    this.debouncedThing(value)
  }

  doTheThing(value) {
    this.setState({
      search: value,
      totalResults: 0,
      instalations: {},
      editedInstalations: {},
      visibleIds: []
    }, () => this.fetchResults())
  }

  handleFilterSubmit(values) {
    this.setState({
      empresa: values.empresa || false,
      tipoInstalacion: values.tipoInstalacion || false,
      decreto: values.decreto || false,
    })
    this.fetchResults()
  }

  handleSelect = (id) => (event) => {
    const selectedIds = new Set(this.state.selectedIds)
    if (selectedIds.has(id)){
      selectedIds.delete(id)
    } else {
      selectedIds.add(id)
    }
    this.setState({ selectedIds: selectedIds })
  }

  handleStatusChange = () => (event) => {
    const instalationId = event.target.name.split(".")[0]
    const fieldName = event.target.name.split(".")[1]
    const instalation = this.state.editedInstalations[Number(instalationId)]
    if (fieldName == 'validacionbbdd'){
      instalation.validacionbbdd = event.target.value
    } 
    if (fieldName == 'validacionactivos'){
      instalation.validacionactivos = event.target.value
    }
    this.setState({
      editedInstalations: {
        ...this.state.editedInstalations,
        [Number(instalationId)]: instalation,
      }
    })
  }

  handleChangeSelectedStatusActivos(newState) {
    const {
      editedInstalations,
      selectedIds,
      tipoInstalacion,
      tiposInstalaciones
    } = this.state

    const schema = tiposInstalaciones[tipoInstalacion].datasheet

    const validatedInstalations = _.cloneDeep(editedInstalations)
    for (let id of selectedIds){
      const [instalationId, decreto] = id.split(".")
      validatedInstalations[instalationId].validacionactivos = newState
      // for (let property in schema.properties) {
      //   if (property === "ESTADO_CERTIFICACION") continue;
      //   if (property === datoTecnico) {
      //     validatedInstalations[instalationId].datasheet["ESTADO_CERTIFICACION"][property] = newState
      //   }
      // }
    }

    this.setState({ editedInstalations: { ...validatedInstalations } })
  }

  handleChangeSelectedStatusSql(newState) {
    const {
      editedInstalations,
      selectedIds,
      tipoInstalacion,
      tiposInstalaciones
    } = this.state

    const schema = tiposInstalaciones[tipoInstalacion].datasheet

    const validatedInstalations = _.cloneDeep(editedInstalations)
    for (let id of selectedIds){
      const [instalationId, datoTecnico] = id.split(".")
      validatedInstalations[instalationId].validacionbbdd = newState
      // for (let property in schema.properties) {
      //   if (property === "ESTADO_CERTIFICACION") continue;
      //   if (property === datoTecnico) {
      //     validatedInstalations[instalationId].datasheet["ESTADO_CERTIFICACION"][property] = newState
      //   }
      // }
    }

    this.setState({ editedInstalations: { ...validatedInstalations } })
  }

  handleChangeAllStatusActivos(newState) {
    const {
      editedInstalations,
      decreto,
      tipoInstalacion,
      tiposInstalaciones,
      visibleIds
    } = this.state

    // const schema = tiposInstalaciones[tipoInstalacion].datasheet
    // console.log(schema)
    const validatedInstalations = {}
    for (let id of visibleIds){
      validatedInstalations[`${id}`] = _.cloneDeep(editedInstalations[`${id}`])
      validatedInstalations[`${id}`].validacionactivos = newState
      // for (let property in schema.properties){
      //   if (property === "ESTADO_CERTIFICACION") continue;
      //   if (!datoTecnico || (!!datoTecnico && property === datoTecnico)) {
      //     validatedInstalations[`${id}`].datasheet["ESTADO_CERTIFICACION"][property] = newState
      //   }
      // }
    }

    this.setState({
      editedInstalations: {
        ...this.state.editedInstalations,
        ...validatedInstalations
      }
    })
  }
  handleChangeAllStatusSql(newState) {
    const {
      editedInstalations,
      datoTecnico,
      tipoInstalacion,
      tiposInstalaciones,
      visibleIds
    } = this.state

    const validatedInstalations = {}
    for (let id of visibleIds){
      validatedInstalations[`${id}`] = _.cloneDeep(editedInstalations[`${id}`])
      validatedInstalations[`${id}`].validacionbbdd = newState
      // for (let property in schema.properties){
      //   if (property === "ESTADO_CERTIFICACION") continue;
      //   if (!datoTecnico || (!!datoTecnico && property === datoTecnico)) {
      //     validatedInstalations[`${id}`].datasheet["ESTADO_CERTIFICACION"][property] = newState
      //   }
      // }
    }

    this.setState({
      editedInstalations: {
        ...this.state.editedInstalations,
        ...validatedInstalations
      }
    })
  }

  handlePageChange(newPage) {
    this.setState({ currentPage: newPage }, () => this.fetchResults())
  }

  // getDecreto = ()  => {
  //   try {
  //       await httpClient(`decretos/`, {
  //           method: "GET",
  //           body: {},
  //           headers: new Headers({ Accept: 'application/json' })
  //       })
  //   } catch (e) {
  //       console.log(e)
  //       return Promise.reject(e)
  //   }
  // }

  handlePerPageChange(newPerPage) {
    this.setState({
      currentPage: 1,
      perPage: newPerPage,
      visibleIds: []
    }, () => this.fetchResults())
  }

  handleSnackbarClose(event, reason) {
    this.setState({ snackbarOpen: false })
  }

  fetchResults() {
    const {
      empresa,
      search,
      tipoInstalacion,
      tiposInstalaciones,
      decreto
    } = this.state
    if (!tipoInstalacion) return;

    const filter = {};
    if (!!empresa) { filter["propietario_id"] = empresa }
    if (!!decreto) { filter["decreto_id"] = decreto }
    if (!!search) { filter["search"] = search }
    const params = {
      pagination: {
        page: this.state.currentPage,
        perPage: this.state.perPage,
      },
      sort: {
        field: this.state.sortColumn,
        order: this.state.sortDirection
      },
      filter
    }
    const resource = tiposInstalaciones[tipoInstalacion].slug
    
    this.setState({ loading: true })
    dataProvider(GET_LIST, resource, params)
      .then(response => {
        const newInstalations = _.keyBy(response.data, 'id')
        this.setState({
          loading: false,
          instalations: {
            ..._.cloneDeep(newInstalations),
            ...this.state.instalations,
          },
          editedInstalations: {
            ..._.cloneDeep(newInstalations),
            ...this.state.editedInstalations
          },
          totalResults: response.total,
          visibleIds: _.map(response.data, r => Number(r.id))
        })
      })
      .catch(error => {
        console.log(error)
      })

    
  }

  handleClear() {
    this.setState({ editedInstalations: _.cloneDeep(this.state.instalations) })
  }

  handleSave() {
    const {
      instalations,
      editedInstalations,
      tipoInstalacion,
      tiposInstalaciones
    } = this.state

    if (!!!tipoInstalacion) return;

    const resource = tiposInstalaciones[tipoInstalacion].slug
    this.setState({ saving: true })
    return Promise.all(_.map(_.values(editedInstalations), instalation => {
      const params = {
        id: instalation.id,
        data: editedInstalations[instalation.id],
        previousData: instalations[instalation.id]
      }
      return dataProvider(UPDATE, resource, params)
        .then(response => {
          this.setState({
            instalations: {
              ...this.state.instalations,
              [Number(instalation.id)]: _.cloneDeep(editedInstalations[instalation.id])
            }
          })
        })
    })).then(() => {
      this.setState({ saving: false, snackbarOpen: true, snackbarError: false })
    }).catch(error => {
      this.setState({ saving: false, snackbarOpen: true, snackbarError: true })
    })
  }

  componentDidMount() {
    const params = {
      pagination: {
        page: 1,
        perPage: 1000,
      },
      sort: { field: 'id', order: 'ASC' },
      filter: {
        active: true,
        id__not_in: "1,2"
      }
    }

    dataProvider(GET_LIST, "tipos-instalaciones", params)
      .then(response => {
        this.setState({
          tiposInstalaciones: _.keyBy(response.data, 'slug'),
          tipoInstalacionChoices: _.map(response.data, tipo => {
            return { value: tipo.slug, text: tipo.name }
          }).sort((a, b) => {
            if (a.text < b.text) return -1
            if (a.text === b.text) return 0
            return 1
          })
        })
      })
      .catch(error => {
        console.log(error)
      })

    const paramsDecreto = {
      pagination: {
        page: 1,
        perPage: 1000
      },
      sort: {
        field: 'id',
        order: 'ASC'
      }
    }
    dataProvider(GET_LIST, 'decretos', paramsDecreto)
      .then(result => {
        result.data.unshift({id: 0, name: "TODOS"})
        this.setState({
          decretoChoices: _.map(result.data, tipo => {
            if (tipo.name === "TODOS") {
              return { value: false, text: "---" }
            }
            return { value: tipo.id, text: tipo.name }
          }).sort((a, b) => {
            if (a.text < b.text) return -1
            if (a.text === b.text) return 0
            return 1
          })
        })
        // console.log(result)
        // if (result.total >= 0){
        //   const decretoChoices = result.data
        //   const title = result.data[0].name
        //   return {
        //     title,
        //     decretoChoices
        //   }
        // } else {
        //   return {
        //     title : "",
        //     decretoChoices: null
        //   }
        // }
      })
  }

  render() {
    const { tipoInstalacion, tiposInstalaciones,decretos} = this.state
    const { classes } = this.props
    const schema = _.get(tiposInstalaciones, `${tipoInstalacion}.datasheet`, {})
    
    return (
      <Authenticated
        authParams={{ required: true, roles: ["admin", "coordinador", "externo"] }}
        location={this.props.location}
      >
        <Card className={classes.root}>
          <CardContent>
            <Typography className={classes.title}>
              <CertificationIcon /> Validar Registros Instalaciones
            </Typography>
            <Grid container spacing={16}>
              <Grid item xs={12}>
                <CertificationFilters
                  tipoInstalacionChoices={this.state.tipoInstalacionChoices}
                  decretoChoices={this.state.decretoChoices}
                  onChange={this.handleFilterChange}
                  onSearchChange={this.handleSearchChange}
                  onSubmit={this.handleFilterSubmit}
                />
              </Grid>
              <Grid item xs={12}>
                {!tipoInstalacion && <p>Escoja un tipo de Instalación</p>}
                {tipoInstalacion && (
                  <CertificationTable
                    instalations={this.state.editedInstalations}
                    ids={this.state.visibleIds}
                    selectedIds={this.state.selectedIds}
                    total={this.state.totalResults}
                    resource={tiposInstalaciones[tipoInstalacion].slug}
                    schema={schema}
                    decreto={this.state.decreto}
                    page={this.state.currentPage}
                    perPage={this.state.perPage}
                    isLoading={this.state.loading}
                    onSelect={this.handleSelect}
                    onStatusChange={this.handleStatusChange}
                    changeSelectedStatusActivos={this.handleChangeSelectedStatusActivos}
                    changeAllStatusActivos={this.handleChangeAllStatusActivos}
                    changeSelectedStatusSql={this.handleChangeSelectedStatusSql}
                    changeAllStatusSql={this.handleChangeAllStatusSql}
                    onClear={this.handleClear}
                    onSave={this.handleSave}
                    onPageChange={this.handlePageChange}
                    onPerPageChange={this.handlePerPageChange}
                  />
                  
                  // <GenericList
                  //   fields={this.state.fields}
                  //   title={this.state.title}
                  // />
                )}
              </Grid>
            </Grid>
          </CardContent>
          <Snackbar
            open={this.state.snackbarOpen}
            onClose={this.handleSnackbarClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            autoHideDuration={6000}
            message={this.state.snackbarError
              ? <span id="message-id">Error al guardar los cambios</span>
              : <span id="message-id">Registros actualizados correctamente</span>
            }
            ContentProps={{
              className: this.state.snackbarError ? classes.snackbarWarning : ""
            }}
          />
        </Card>
      </Authenticated>
    )
  }
}

export default withRouter(withStyles(styles)(ValidarInstalaciones))
